import AddStepAction from "../../actions/scenario/AddStepAction";
import Scenario from "../scenarioElements/Scenario";
import Step from "../scenarioElements/Step";

export default class ScenarioUtils
{
	static isValidProjectName(projectName: string): boolean 
	{
		if(!projectName) return false; // project name cannot be empty or undefined

		const invalidProjectNameCharacters = [];
		return !invalidProjectNameCharacters.some(char => projectName.includes(char));
	}

	static generateStepRelationsMap(clonedSteps: Step[])
	{
		const stepRelationsMap = new Map<string, string>();
		for(const clonedStep of clonedSteps)
		{
			if(clonedStep.copyOf)
			{
				stepRelationsMap.set(clonedStep.copyOf, clonedStep.id);
			}
		}
		return stepRelationsMap;
	}

	static generateContinueStep(sourceStep: Step): Step | undefined
	{
		if(!Scenario.currentSequence()) return;

		let stepToContinue = sourceStep;
		if(sourceStep.isDefault() || sourceStep.isTrackersStep())
		{
			const continuableSteps = Scenario.currentSequence()!.steps.filter(step => !step.isDefault() && !step.isTrackersStep());
			stepToContinue = continuableSteps[continuableSteps.length - 1];
		}
		const clonedStep = stepToContinue.clone({ continues: true });
		new AddStepAction(Scenario.currentSequence()!, clonedStep);

		return clonedStep;
	}
}